import { motion } from "framer-motion";
import { Truck, ShieldCheck, Bitcoin, MapPin } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { useT } from "../lib/i18n";

const Tile = ({ className = "", delay = 0, children, testid }) => (
  <motion.div data-testid={testid} initial={{ opacity: 0.001, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }} whileHover={{ y: -6 }}
    className={`relative overflow-hidden rounded-[28px] p-7 md:p-10 flex flex-col ${className}`}>
    {children}
  </motion.div>
);

export const Services = () => {
  const { svc: s } = useT();
  return (
  <section id="servizi" className="py-20 md:py-32 bg-[var(--paper)] border-y border-[var(--line)]" data-testid="services-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <Reveal className="max-w-3xl mb-12 md:mb-16">
        <Eyebrow>{s.eyebrow}</Eyebrow>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[0.95]">
          {s.t1} <span className="font-serif-i font-normal">{s.em}</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-6 gap-5 md:auto-rows-[minmax(260px,auto)]">
        <Tile testid="service-shipping" className="md:col-span-4 md:row-span-2 bg-[var(--ink)] text-white min-h-[420px]">
          <img src="/img/p911.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-55" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
          <div className="relative mt-auto">
            <Truck className="w-9 h-9 text-[var(--red)] mb-6" strokeWidth={1.5} />
            <h3 className="font-display text-3xl md:text-5xl font-semibold tracking-tight leading-[1]">{s.ship1}<br /><span className="font-serif-i font-normal">{s.ship2}</span></h3>
            <p className="mt-5 max-w-lg text-white/80">{s.shipTxt}</p>
          </div>
        </Tile>
        <Tile testid="service-refund" delay={0.1} className="md:col-span-2 bg-[var(--red)] text-white">
          <ShieldCheck className="w-9 h-9 mb-auto" strokeWidth={1.5} />
          <p className="mt-10 font-mono text-[11px] uppercase tracking-[0.25em] text-white/80">{s.refundLabel}</p>
          <h3 className="font-display text-3xl font-semibold tracking-tight leading-[1.02] mt-2">{s.refundT}</h3>
          <p className="mt-3 text-white/85 text-sm">{s.refundTxt}</p>
        </Tile>
        <Tile testid="service-crypto" delay={0.2} className="md:col-span-2 bg-white border border-[var(--line)]">
          <Bitcoin className="w-9 h-9 text-[var(--red)] mb-auto" strokeWidth={1.5} />
          <p className="mt-10 font-mono text-[11px] uppercase tracking-[0.25em] text-[var(--muted)]">{s.cryptoLabel}</p>
          <h3 className="font-display text-3xl font-semibold tracking-tight leading-[1.02] mt-2">{s.cryptoT}</h3>
          <p className="mt-3 text-[var(--ink-2)] text-sm">{s.cryptoTxt}</p>
        </Tile>
        <Tile testid="service-showroom" delay={0.1} className="md:col-span-6 bg-[var(--bone)] border border-[var(--line)] md:flex-row md:items-center gap-6">
          <MapPin className="w-9 h-9 text-[var(--red)] shrink-0" strokeWidth={1.5} />
          <h3 className="font-display text-2xl md:text-3xl font-semibold tracking-tight flex-1">{s.showroomT} <span className="font-serif-i font-normal">Corso Bergamo 108/D, Lecco.</span></h3>
        </Tile>
      </div>
    </div>
  </section>
  );
};
